import AuthLayout from "../../layouts/Auth.layout";
import { AuthWrapper, ConfirmNumberForm } from "../../components/forms/auth";

export const ConfirmNumber = () => {
  return (
    <AuthLayout>
      <AuthWrapper form={<ConfirmNumberForm />}>
        <div className="font-manrope text-base text-gray-300 flex flex-row gap-x-6 mb-8">
          We’ve sent a message to your phone number
        </div>
        <div className="font-poppins text-5xl	text-gray-500">
          Confirm your
          <br />
          number
        </div>
      </AuthWrapper>
    </AuthLayout>
  );
};
